import {CountryApiModel} from "../../common/country/models/country-api-model";
import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {PartialGameApiModel} from "../../partial-game/models/partial-game-api-model";
import {BookmakerApiModel} from "../../common/bookmaker/models/bookmaker-api-model";

export class H2hResponseApiModel extends BaseApiResponseModel {
  countries: Array<CountryApiModel>;
  sports: Array<SportApiModel>;
  competitions: Array<CompetitionApiModel>;
  game: Array<PartialGameApiModel>;
  bookmakers: Array<BookmakerApiModel>;

  constructor(model: H2hResponseApiModel) {
    super(model);

    this.sport = model?.sport;
    this.countries = model?.countries;
    this.competitions = model?.competitions;
    this.game = model?.game;
    this.bookmakers = model?.bookmakers;
  }
}
